/**
 * Normalises the two response shapes the backend can return for a
 * home_collage_order validation error (Redmine #266343/#266412):
 *   - the shared Masterlist update pipeline: { success: false, message, error, conflict }
 *   - the Location-specific route: { error, conflict } (no `message` key)
 *
 * `conflict` is only present when the rejection is a confirmable slot clash
 * ({ field, value, alias, display_name }) -- a hard validation error (e.g. out
 * of range) or a real server failure has conflict: null/absent, so callers
 * should fall back to a generic error toast in that case rather than opening
 * the reassign dialog.
 */
export const parseHomeCollageConflict = (error) => {
  const data = error?.response?.data;
  const conflict = data?.conflict || null;
  const message = data?.message ?? data?.error ?? error?.message ?? null;
  return { conflict, message };
};
